import { extensionDecorator, NodeExtension, ExtensionTag, findSelectedNodeOfType, object, presetDecorator, Preset } from '@remirror/core';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { cx } from 'linaria';
import { stringify, parse } from 'tiny-querystring';

var _dec, _class, _temp;
var IframeExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultOptions: {
    defaultSource: '',
    class: 'remirror-iframe'
  },
  staticKeys: ['class', 'class']
}), /*#__PURE__*/_dec(_class = (_temp = class IframeExtension extends NodeExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "tags", [ExtensionTag.BlockNode]);

    _defineProperty(this, "addIframe", attributes => {
      return (_ref) => {
        var state = _ref.state,
            dispatch = _ref.dispatch;
        var tr = state.tr.replaceSelectionWith(this.type.create(attributes));

        if (dispatch) {
          dispatch(tr);
        }

        return true;
      };
    });

    _defineProperty(this, "addYouTubeVideo", parameter => {
      return this.addIframe({
        src: createYouTubeUrl(parameter),
        frameBorder: 0,
        type: 'youtube',
        allowFullScreen: 'true'
      });
    });

    _defineProperty(this, "updateIframeSource", src => {
      return (_ref2) => {
        var state = _ref2.state,
            dispatch = _ref2.dispatch;
        var tr = state.tr;
        var found = findSelectedNodeOfType({
          selection: tr.selection,
          types: this.type
        });

        if (!found) {
          return false;
        }

        tr.setNodeMarkup(found.pos, undefined, _objectSpread(_objectSpread({}, found.node.attrs), {}, {
          src
        }));

        if (dispatch) {
          dispatch(tr);
        }

        return true;
      };
    });

    _defineProperty(this, "updateYouTubeVideo", parameter => {
      return this.updateIframeSource(createYouTubeUrl(parameter));
    });
  }

  get name() {
    return 'iframe';
  }

  createNodeSpec(extra) {
    var defaultSource = this.options.defaultSource;
    return {
      attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
        src: defaultSource ? {
          default: defaultSource
        } : {},
        allowFullScreen: {
          default: true
        },
        frameBorder: {
          default: 0
        },
        type: {
          default: 'custom'
        },
        width: {
          default: null
        },
        height: {
          default: null
        }
      }),
      selectable: false,
      parseDOM: [{
        tag: 'iframe',
        getAttrs: dom => {
          var frameBorder = dom.getAttribute('frameborder');
          return _objectSpread(_objectSpread({}, extra.parse(dom)), {}, {
            type: dom.getAttribute('data-embed-type'),
            height: dom.getAttribute('height'),
            width: dom.getAttribute('width'),
            allowFullScreen: dom.getAttribute('allowfullscreen') === 'false' ? false : true,
            frameBorder: frameBorder ? Number.parseInt(frameBorder, 10) : 0,
            src: dom.getAttribute('src')
          });
        }
      }],
      toDOM: node => {
        var _node$attrs = node.attrs,
            frameBorder = _node$attrs.frameBorder,
            allowFullScreen = _node$attrs.allowFullScreen,
            src = _node$attrs.src,
            type = _node$attrs.type,
            rest = _objectWithoutProperties(_node$attrs, ["frameBorder", "allowFullScreen", "src", "type"]);

        var className = this.options.class;
        return ['iframe', _objectSpread(_objectSpread(_objectSpread({}, extra.dom(node)), rest), {}, {
          class: cx(className, "".concat(className, "-").concat(type)),
          src,
          'data-embed-type': type,
          allowfullscreen: allowFullScreen ? 'true' : 'false',
          frameBorder: frameBorder.toString()
        })];
      }
    };
  }
  /**
   * Provides the commands for the iFrame extension.
   */


  createCommands() {
    return {
      /**
       * Add a custom iFrame to the editor.
       */
      addIframe: attributes => this.addIframe(attributes),

      /**
       * Add a YouTube embedded iFrame to the editor.
       */
      addYouTubeVideo: parameter => this.addYouTubeVideo(parameter),

      /**
       * Update the iFrame source for the currently selected video.
       */
      updateIframeSource: src => this.updateIframeSource(src),

      /**
       * Update the YouTube video iFrame.
       */
      updateYouTubeVideo: parameter => this.updateYouTubeVideo(parameter)
    };
  }
  /**
   * Creates the command for adding an iFrame to the editor.
   */


}, _temp)) || _class);

/**
 * A Url parser that relies on the browser for the majority of the work.
 */
function parseUrl(url) {
  var parser = document.createElement('a'); // Let the browser do the work

  parser.href = url;
  var searchObject = parse(parser.search.replace(/^\?/, ''));
  return {
    protocol: parser.protocol,
    host: parser.host,
    hostname: parser.hostname,
    port: parser.port,
    pathname: parser.pathname,
    search: parser.search,
    searchObject,
    hash: parser.hash
  };
}

function createYouTubeUrl(parameter) {
  var _ref3, _parseUrl, _parseUrl$searchObjec;

  var video = parameter.video,
      _parameter$enhancedPr = parameter.enhancedPrivacy,
      enhancedPrivacy = _parameter$enhancedPr === void 0 ? true : _parameter$enhancedPr,
      _parameter$showContro = parameter.showControls,
      showControls = _parameter$showContro === void 0 ? true : _parameter$showContro,
      _parameter$startAt = parameter.startAt,
      startAt = _parameter$startAt === void 0 ? 0 : _parameter$startAt;
  var id = (_ref3 = (_parseUrl = parseUrl(video)) === null || _parseUrl === void 0 ? void 0 : (_parseUrl$searchObjec = _parseUrl.searchObject) === null || _parseUrl$searchObjec === void 0 ? void 0 : _parseUrl$searchObjec.v) !== null && _ref3 !== void 0 ? _ref3 : video;
  var urlStart = enhancedPrivacy ? 'https://www.youtube-nocookie.com' : 'https://www.youtube.com';
  var searchObject = object();

  if (!showControls) {
    searchObject.controls = '0';
  }

  if (startAt) {
    searchObject['amp;start'] = startAt;
  }

  return "".concat(urlStart, "/embed/").concat(id, "?").concat(stringify(searchObject));
}

var _dec$1, _class$1;
var EmbedPreset = (_dec$1 = /*#__PURE__*/presetDecorator({
  defaultOptions: IframeExtension.defaultOptions,
  staticKeys: ['class', 'defaultSource']
}), /*#__PURE__*/_dec$1(_class$1 = class EmbedPreset extends Preset {
  get name() {
    return 'embed';
  }

  onSetOptions(_parameter) {}

  createExtensions() {
    var defaultSource = this.options.defaultSource;
    return [new IframeExtension({
      defaultSource
    })];
  }

}) || _class$1);

export { EmbedPreset, IframeExtension };
